<template>
    <div class="container" style="margin-top: 50px;">
        <div class="text-center">
            <h4>{{title}}</h4><br>
            <div style="max-width: 600px; margin: 0 auto;">
                <div v-if="success !== ''" class="alert alert-success my-2" role="alert">
                    {{success}}
                </div>
                <form enctype="multipart/form-data">
                    <div class="container">
                        <v-row>
                            <div class="custom-file">
                                <input 
                                    type="file" 
                                    v-bind:accept="fileFilterValue" 
                                    name="filename" 
                                    class="custom-file-input" 
                                    id="inputFileUpload"
                                    v-on:change="onFileChange"/>

                                <label class="custom-file-label" for="inputFileUpload">{{ filename }}</label>
                            </div>
                        </v-row>
                        <v-row class="my-2 text-center" >
                            <v-btn class="my-2" color="primary" v-bind:loading="working" @click="submitForm($event)">ΑΝΕΒΑΣΜΑ</v-btn>
                        </v-row>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component successfully mounted')

            console.log(`Filter: ${this.fileFilterValue} / Target: ${this.target}`)

        },
        data() {
            return {
                filename: '',
                file: '',
                success: '',

                working: false,
            };
        },
        props : {
            target: String,
            title: String,
            filter: String
        },

        computed : {
            fileFilterValue() {
                return this.filter
            }
        },

        methods: {
            onFileChange(e) {
                //console.log(e.target.files[0]);
                this.filename = e.target.files[0].name;
                this.file = e.target.files[0];
            },
            submitForm(e) {
                e.preventDefault();

                this.working = true;
                this.success = '';


                let currentObj = this;
                
                const config = {
                    headers: {
                        'content-type': 'multipart/form-data',
                        //'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                    }
                }

                // form data
                let formData = new FormData();
                formData.append('file', this.file);

                // send upload request

                // axios.post('/api/company/logo2', formData, config)
                axios.post(this.target, formData, config)
                    .then(function (response) {
                        currentObj.success = "Το αρχείο αποθηκεύτηκε επιτυχώς";
                        currentObj.filename = "";

                        currentObj.working = false;
                    })
                    .catch(function (error) {
                        currentObj.output = error;
                        console.log(error);
                        currentObj.working = false;
                    });
            }
        }
    }
</script>